export const rodent = [
   "Rat",
   "Guinea Hog",
   "Guinea Pig",
   "Guinea Pig - English Shorthair",
   "Guinea Pig - Peruvian Longhair",
]
